import { render, staticRenderFns } from "./my_praise.vue?vue&type=template&id=29f52042&scoped=true&"
import script from "./my_praise.vue?vue&type=script&lang=js&"
export * from "./my_praise.vue?vue&type=script&lang=js&"
import style0 from "./my_praise.vue?vue&type=style&index=0&id=29f52042&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f52042",
  null
  
)

export default component.exports